$(document).ready(function() {
  $(".faq__sidebar ul li a[href*='#']:not([href='#])").click(function() {
    let target = $(this).attr("href");
    $('html,body').stop().animate({
      scrollTop: $(target).offset().top - 80
    }, 1000);
    event.preventDefault();
  });

  $(".faq__search select").change(function(){
    var id = $(this).val();
    $('html,body').stop().animate({
      scrollTop: $("#topic-"+id).offset().top - 80
    }, 1000);
  });

  $('.faq__search-input input').on("change keyup input",function() { 
    var v = $(this).val();
    if(v != ""){
      $(".faq__list .faq__category-wrapper").hide();
      $(".faq__list .faq__item").hide();
      $(".faq__list .faq__item").each(function(){
        var question = $(this).find(".faq-item__button").text();
        var answer = $(this).find(".faq-item__answer").text();
        if(question.indexOf(v) >= 0 || answer.indexOf(v) >= 0){
          $(this).show();
        }
      });
    }else{
      $(".faq__list .faq__category-wrapper").show();
      $(".faq__list .faq__item").show();
    }
  });

  $(".read-hero__highlight-label .icon-info").click(function(){
    var id = $(this).parents(".read-hero__highlight").data("block");
    if ($('#read-hero__'+id).length) {
      $.magnificPopup.open({
        items: {
          src: '#read-hero__'+id 
        },
        type: 'inline',
        callbacks: {
          open: function () {
            $(".mfp-close").text("CLOSE");
          }
        }
      });
    }
  });

  $(".product__info-container .icon-with-text__item svg").click(function(){
    if ($('#product-membership-popup').length) {
      $.magnificPopup.open({
        items: {
          src: '#product-membership-popup'
        },
        type: 'inline',
        callbacks: {
          open: function () {
            $(".mfp-close").text("CLOSE");
          }
        }
      });
    }
  });

  $(".membership-bookclub").click(function(){
    $("body").addClass("membership-bookclub__open");
  });
  $("#membership-bookclub-popup .popup-close").click(function(){
    $("body").removeClass("membership-bookclub__open");
  });
  $(document).mouseup(function(e){
    var container = $("#membership-bookclub-popup");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $("body").removeClass("membership-bookclub__open");
    }
  });
});

$(function(){
  $(".slider-text").slick({
    infinite: true,
    vertical: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  if($(window).width() < 990){
    $(".multicolumn-list").slick({
      infinite: false,
      arrows: true,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      nextArrow: '<div class="arrow-right"><svg class="product-carousel__icon" width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.82031 10.5602L16.3472 10.5602M16.3472 10.5602L11.2943 16.3545M16.3472 10.5602L11.2943 5.01789" stroke="currentcolor" stroke-width="1.26923" stroke-linecap="square" stroke-linejoin="round"></path></svg></div>',
      prevArrow: '<div class="arrow-left"><svg class="product-carousel__icon product-carousel__icon--horizontally-flipped" width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.82031 10.5602L16.3472 10.5602M16.3472 10.5602L11.2943 16.3545M16.3472 10.5602L11.2943 5.01789" stroke="currentcolor" stroke-width="1.26923" stroke-linecap="square" stroke-linejoin="round"></path></svg></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
});